import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Loader, Collapsible, BaasicHeader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import {
	FulfillmentOrdersList,
	OrderLinesList,
	MarketplaceOrderHistoryLogList,
	ReturnedItemsList,
} from 'modules/order/pages';
import { channelType, orderStatus } from 'common/constants';
import { isShippingStateAvailable, renderIf } from 'core/utils';
import _ from 'lodash';
import 'moment-timezone';

const MarketplaceOrderDetailTemplate = ({
	marketplaceOrderDetailViewStore: {
		loading,
		fulfillmentOrders,
		orderLines,
		shipmentInfoReturns,
		refreshPage,
		splitOrder,
		isReadyForSplitting,
		hasUnlinkedOrderLines,
		hasState,
		hasFulfillmentOrders,
		order,
		itemPrice,
		hasPiiAccess,
		rootStore,
		showSplitOption,
		isBuyerRequestedCancel,
		hasNoShipmentInfos,
		hasAllFOsPastExitScan,
		isSuperAdminOrganization,
		openReplacementModal,
		openConfirmationModal,
		getRefundConfirmModalProps,
		getCancelOrderConfirmModalProps,
	},
	t,
}) => {
	if (loading) return <Loader />;
	return (
		<div>
			<ReactTooltip />
			<div className="order">
				<BaasicHeader rootStore={rootStore} title={'MARKETPLACEORDERDETAILVIEW.LABEL.MARKETPLACEORDERDETAIL'}>
					{/* Replace */}
					{isReplaceAvailable(order) && (
						<button className="btn btn--white" type="button" onClick={openReplacementModal}>
							<i title={t('REPLACE')} className="fa fa-retweet spc--right--tny k-custom-clickable"></i>
							{t('REPLACE')}
						</button>
					)}

					{/* Create Return Label */}
					{order.orderLines.some(ol => ol.productId && ol.product.isShippable) && // If productId exists, it indicates that the product is linked.
						hasPiiAccess &&
						order.orderStatus.abrv != orderStatus.canceled && (
							<button
								className="btn btn--white"
								type="button"
								onClick={() =>
									rootStore.routerStore.goTo('master.app.main.order.marketplace.list.return-label', { id: order.id })
								}
							>
								<i title={t('RETURNLABEL')} className="fas fa-reply spc--right--sml k-custom-clickable"></i>
								{t('RETURNLABEL')}
							</button>
						)}

					{/* Edit */}
					{order.channel.channelType.name == channelType.manualOrders && hasPiiAccess && !hasUnlinkedOrderLines && (
						<button
							className="btn btn--white"
							type="button"
							onClick={() =>
								rootStore.routerStore.goTo('master.app.main.order.list.edit', {
									id: order.id,
								})
							}
						>
							<i title={t('EDIT')} className="fa fa-edit spc--right--sml k-custom-clickable"></i>
							{t('EDIT')}
						</button>
					)}

					{/* Cancel */}
					{((order.channel.channelType.name == channelType.amazon && isBuyerRequestedCancel) ||
						(order.channel.channelType.name == channelType.mirakl && order.CanCancel)) &&
						hasPiiAccess &&
						hasNoShipmentInfos &&
						order.orderStatus.abrv != orderStatus.canceled &&
						order.orderStatus.abrv != orderStatus.shipped && (
							<button
								className="btn btn--white"
								type="button"
								onClick={() => openConfirmationModal(getCancelOrderConfirmModalProps())}
							>
								<i title={t('CANCEL')} className="fa fa-window-close spc--right--sml k-custom-clickable"></i>
								{t('CANCEL')}
							</button>
						)}
					{order.channel.channelType.name == channelType.amazon &&
						hasPiiAccess &&
						hasFulfillmentOrders &&
						hasAllFOsPastExitScan && (
							<button
								className="btn btn--white"
								type="button"
								onClick={() => openConfirmationModal(getRefundConfirmModalProps())}
							>
								<i title={t('REFUND')} className="fa fa-hand-holding-usd spc--right--sml k-custom-clickable"></i>
								{t('REFUND')}
							</button>
						)}
				</BaasicHeader>
				<div className="order__wrapper">
					<div className="order__header">
						<div className="container--fluid">
							<div className="row">
								<div className="col col-sml-6 col-med-6 col-xlrg-2 col-xxlrg-2 spc--bottom--sml">
									<div className="order__header__item fullheight">
										<h4 className="order__header__title type--base">{t('MARKETPLACEORDERDETAILVIEW.LABEL.CHANNEL')}</h4>
										<p>{order.channel.name}</p>
									</div>
								</div>
								<div className="col col-sml-6 col-med-6 col-xlrg-2 col-xxlrg-2 spc--bottom--sml">
									<div className="order__header__item fullheight">
										<h4 className="order__header__title type--base">
											{t('MARKETPLACEORDERDETAILVIEW.LABEL.ORDERNUMBER')}
										</h4>
										<p data-cy={'orderNumber'}>
											{order.orderNumber}{' '}
											{renderIf(hasUnlinkedOrderLines != undefined)(
												<i
													data-tip={t('MARKETPLACEORDERDETAILVIEW.UNLINKEDORDERLINES')}
													className="fas fa-exclamation-circle"
												/>
											)}
											{renderIf(!hasState)(
												<i data-tip={t('MARKETPLACEORDERDETAILVIEW.HASNOSTATE')} className="fas fa-globe" />
											)}
										</p>
									</div>
								</div>
								{order.CustomerOrderId != null && (
									<div className="col col-sml-6 col-med-6 col-xlrg-2 col-xxlrg-2 spc--bottom--sml">
										<div className="order__header__item fullheight">
											<h4 className="order__header__title type--base">
												{t('MARKETPLACEORDERDETAILVIEW.LABEL.CUSTOMERORDERID')}
											</h4>
											<p>{order.CustomerOrderId}</p>
										</div>
									</div>
								)}
								<div className="col col-sml-6 col-med-6 col-xlrg-2 col-xxlrg-2 spc--bottom--sml">
									<div className="order__header__item fullheight">
										<h4 className="order__header__title type--base">
											{t('MARKETPLACEORDERDETAILVIEW.LABEL.ORDERSTATUS')}
										</h4>
										<p>{order.orderStatus.name}</p>
									</div>
								</div>
								<div className="col col-sml-6 col-med-6 col-xlrg-2 col-xxlrg-2 spc--bottom--sml">
									<div className="order__header__item fullheight">
										<h4 className="order__header__title type--base">{t('MARKETPLACEORDERDETAILVIEW.LABEL.ISPRIME')}</h4>
										{order.isPrime ? (
											<i className="icon icon--xlrg icon--prime" />
										) : (
											<i className="icon icon--xlrg icon--prime--grey" />
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="order__details">
						<div className="container--fluid">
							<div className="row">
								<div className="col col-sml-12">
									<div className="order__box">
										<h4 className="order__box__title">{t('GENERALINFORMATION')}</h4>
										<div className="order__box__content">
											<div className="row">
												<div className="col col-sml-4">
													<div>
														<div className="order__header__item">
															<h4 className="order__header__title">{t('MARKETPLACEORDERDETAILVIEW.LABEL.CUSTOMER')}</h4>
														</div>
														<div className="order__box__content">
															{order.buyerName != null && (
																<span>
																	<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.CUSTOMERNAME')}</p>
																	<p className="fs-mask">{order.buyerName}</p>
																</span>
															)}

															<p className="order__label spc--top--sml">
																{t('MARKETPLACEORDERDETAILVIEW.LABEL.EMAIL')}
															</p>
															<p>{order.buyerEmail}</p>

															<p className="order__label spc--top--sml">
																<span>{t('MARKETPLACEORDERDETAILVIEW.LABEL.ADDRESS')}</span>
																{order.addressChanged && (
																	<i
																		className="icon icon--xmed icon--location-check--primary spc--left--nano"
																		data-tip={t('MARKETPLACEORDERDETAILVIEW.ADDRESSCHANGED')}
																	></i>
																)}
															</p>
															{order.buyerName != null && <p className="fs-mask">{order.buyerName}</p>}
															<p className="fs-mask">{order.shippingAddress1}</p>
															{order.shippingAddress2 != '' && <p className="fs-mask">{order.shippingAddress2}</p>}
															{order.shippingAddress3 != '' && <p className="fs-mask">{order.shippingAddress3}</p>}
															<p>
																{order.shippingCity},{' '}
																{order.shippingCoreCountryState != null && order.shippingCoreCountryState.name}{' '}
																{order.shippingZipCode}
															</p>

															{order.buyerPhone != null && (
																<span>
																	<p className="order__label spc--top--sml">
																		{t('MARKETPLACEORDERDETAILVIEW.LABEL.PHONE')}
																	</p>
																	<p className="fs-mask">{order.buyerPhone}</p>
																</span>
															)}
														</div>
													</div>
												</div>
												<div className="col col-sml-4">
													<div>
														<div className="order__header__item">
															<h4 className="order__header__title">{t('MARKETPLACEORDERDETAILVIEW.LABEL.SHIPPING')}</h4>
														</div>
														<div className="order__box__content">
															<p className="order__label">
																<span>{t('MARKETPLACEORDERDETAILVIEW.LABEL.ADDRESS')}</span>
																{(order.shippingCoreCountry == null ||
																	(isShippingStateAvailable(order.shippingCoreCountry.countryCode) &&
																		order.shippingCoreCountryState == null)) &&
																	order.orderStatus.abrv === orderStatus.unshipped && (
																		<span>
																			<i
																				data-tip={t('MARKETPLACEORDERDETAILVIEW.MISSINGDATA')}
																				className="fas fa-exclamation-circle"
																			/>
																		</span>
																	)}
																{order.addressChanged && (
																	<i
																		className="icon icon--xmed icon--location-check--primary spc--left--nano"
																		data-tip={t('MARKETPLACEORDERDETAILVIEW.ADDRESSCHANGED')}
																	></i>
																)}
															</p>
															{order.buyerName != null && <p className="fs-mask">{order.buyerName}</p>}

															<p className="fs-mask">{order.shippingAddress1}</p>
															{order.shippingAddress2 != '' && <p className="fs-mask">{order.shippingAddress2}</p>}
															{order.shippingAddress3 != '' && <p className="fs-mask">{order.shippingAddress3}</p>}
															<p>
																{order.shippingCity},{' '}
																{order.shippingCoreCountryState != null && order.shippingCoreCountryState.name}{' '}
																{order.shippingZipCode}
															</p>
															{order.buyerPhone != null && (
																<span>
																	<p className="order__label spc--top--sml">
																		{t('MARKETPLACEORDERDETAILVIEW.LABEL.PHONE')}
																	</p>
																	<p className="fs-mask">{order.buyerPhone}</p>
																</span>
															)}

															<p className="order__label spc--top--sml">
																{t('MARKETPLACEORDERDETAILVIEW.LABEL.CARRIERSERVICE')}
															</p>
															<p>{order.requiredCarrierService ? order.requiredCarrierService : '-'}</p>

															<p className="order__label spc--top--sml">
																{t('MARKETPLACEORDERDETAILVIEW.LABEL.SHIPBYDATE')}
															</p>
															<p>{order.shipByDate}</p>
														</div>
													</div>
												</div>
												<div className="col col-lrg-4">
													<div>
														<div className="order__header__item">
															<h4 className="order__header__title">
																{t('MARKETPLACEORDERDETAILVIEW.LABEL.MASTERORDER')}
															</h4>
														</div>
														<div className="order__box__content">
															<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.ORDERDATE')}</p>
															<p>{order.orderDate}</p>

															{order.customerServiceOrderNumber != null && order.customerServiceOrderNumber != '' && (
																<React.Fragment>
																	<div className="separator--primary spc--top--sml spc--bottom--sml"></div>
																	<p className="order__label">
																		{t('MARKETPLACEORDERDETAILVIEW.LABEL.CUSTOMERSERVICEORDERNUMBER')}
																	</p>
																	<p>{order.customerServiceOrderNumber}</p>
																</React.Fragment>
															)}

															{(order.ref1 || order.ref2 || order.ref3) && (
																<React.Fragment>
																	<div className="separator--primary spc--top--sml spc--bottom--sml"></div>
																	{order.ref1 && (
																		<React.Fragment>
																			<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.REF1')}</p>
																			<p>{order.ref1}</p>
																		</React.Fragment>
																	)}
																	{order.ref2 && (
																		<React.Fragment>
																			<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.REF2')}</p>
																			<p>{order.ref2}</p>
																		</React.Fragment>
																	)}
																	{order.ref3 && (
																		<React.Fragment>
																			<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.REF3')}</p>
																			<p>{order.ref3}</p>
																		</React.Fragment>
																	)}
																</React.Fragment>
															)}

															{order.source != null && order.source != '' && (
																<React.Fragment>
																	<div className="separator--primary spc--top--sml spc--bottom--sml"></div>
																	<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.CHANNELSOURCE')}</p>
																	<p>{order.source}</p>
																</React.Fragment>
															)}

															<div className="separator--primary spc--top--sml spc--bottom--sml"></div>

															<div className="row">
																<div className="col col-sml-6">
																	<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.ITEMPRICE')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right">{itemPrice}</p>
																</div>
															</div>

															<div className="row spc--top--sml">
																<div className="col col-sml-6">
																	<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.TOTALTAX')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right">{order.taxPaid}</p>
																</div>
															</div>
															<div className="row spc--top--sml">
																<div className="col col-sml-6">
																	<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.TOTALSHIPPING')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right">{order.shippingPaid}</p>
																</div>
															</div>
															<div className="row spc--top--sml">
																<div className="col col-sml-6">
																	<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.SUBTOTAL')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right">{itemPrice}</p>
																</div>
															</div>
															<div className="row spc--top--sml">
																<div className="col col-sml-6">
																	<p className="order__label">{t('MARKETPLACEORDERDETAILVIEW.LABEL.DISCOUNT')}</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right">{order.discount * -1}</p>
																</div>
															</div>
															<div className="row spc--top--sml">
																<div className="col col-sml-6">
																	<p className="order__label type--lrg">
																		{t('MARKETPLACEORDERDETAILVIEW.LABEL.TOTALPAID')}
																	</p>
																</div>
																<div className="col col-sml-6">
																	<p className="type--right type--lrg">{order.amountPaid}</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						{/* Order Lines collapsible */}
						<div className="order__box--no-padd spc--top--med">
							<Collapsible expanded={true} title={t('MARKETPLACEORDERDETAILVIEW.LABEL.ORDERLINES')}>
								{isReadyForSplitting && (
									<button
										className="btn btn--med btn--primary spc--top--sml spc--left--sml spc--right--sml"
										type="button"
										onClick={splitOrder}
										disabled={
											hasUnlinkedOrderLines != undefined ||
											hasFulfillmentOrders ||
											!showSplitOption ||
											!isSuperAdminOrganization
										}
									>
										{t('MARKETPLACEORDERDETAILVIEW.LABEL.SPLITORDER')}
									</button>
								)}
								<OrderLinesList
									data={orderLines.slice()}
									refreshPage={refreshPage}
									channel={order.channel}
									hasAllFOsPastExitScan={hasAllFOsPastExitScan}
								/>
							</Collapsible>
						</div>

						{/* Fulfillment Orders collapsible. */}
						<div className="order__box--no-padd spc--top--med">
							<Collapsible title={t('FULFILLMENTORDERVIEW.ORDER')}>
								<FulfillmentOrdersList data={fulfillmentOrders.slice()} />
							</Collapsible>
						</div>

						{/* Returned Items collapsible. */}
						{shipmentInfoReturns.length > 0 && (
							<div className="order__box--no-padd spc--top--med">
								<Collapsible title={t('MARKETPLACEORDERDETAILVIEW.LABEL.RETURNEDITEMS')}>
									<ReturnedItemsList data={shipmentInfoReturns.slice()} />
								</Collapsible>
							</div>
						)}

						{/* View Activity (History Log) collapsible. */}
						<div className="spc--top--med">
							<Collapsible title={t('FULFILLMENTORDERVIEW.HISTORYLOG.VIEWACTIVITY')}>
								<MarketplaceOrderHistoryLogList />
							</Collapsible>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const isReplaceAvailable = order => {
	return (
		_.some(order.orderLines, orderLine => {
			return (
				orderLine.productVirtualSkuId &&
				orderLine.product &&
				orderLine.product.isActive &&
				orderLine.product.isShippable
			);
		}) &&
		order.channel.channelType.name != channelType.amazonVendor &&
		order.orderStatus.abrv !== orderStatus.canceled
	);
};

export default defaultTemplate(MarketplaceOrderDetailTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/MarketplaceOrderDetailTemplate.jsx